import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "../KioskShopList.module.css";

const KioskShopListSkeleton = ({ mutilRow }) => {
  const singleRow = (
    <div className="row shop-row">
      {Array.apply(0, Array(16)).map((n, i) => (
        <div className="col-3" key={i} style={{ marginBottom: "12px", lineHeight: 1 }}>
          <Skeleton height={112}  />
        </div>
      ))}
    </div>
  );

  let skeleton = singleRow;
  if (mutilRow) {
    const rows = [1, 2, 3].map((n) => (
      <div className={styles.ShopGroup} key={n}>
        <h3 className={styles.GroupTitle}>
          <Skeleton count={1} style={{ width: "30%" }} />
        </h3>
        {singleRow}
      </div>
    ));

    skeleton = (
      <>
        <h2 style={{ width: "60%", height: 44, marginBottom: 36 }}>
          <Skeleton count={1} />
        </h2>
        <div className={styles.List}> {rows} </div>
      </>
    );
  }

  return skeleton;
};

export default KioskShopListSkeleton;
